import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';

interface Opportunity {
  id: string;
  name: string;
  address: string;
  postcode: string;
  package: string;
  totalValue: string;
  speed: string;
  status: 'won' | 'qualified' | 'open' | 'lost';
  created: string;
  updated: string;
}

interface TrackerStats {
  open: number;
  qualified: number;
  won: number;
  lost: number;
  totalValue: string;
}

@Component({
  selector: 'app-sales-opportunities-tracker',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule
  ],
  templateUrl: './sales-opportunities-tracker.component.html',
  styleUrls: ['./sales-opportunities-tracker.component.scss']
})
export class SalesOpportunitiesTrackerComponent implements OnInit {
  dialogRef = inject<MatDialogRef<SalesOpportunitiesTrackerComponent>>(MatDialogRef);

  selectedFilter: 'all' | 'open' | 'qualified' | 'won' | 'lost' = 'all';
  stats: TrackerStats = {
    open: 3,
    qualified: 14,
    won: 13,
    lost: 0,
    totalValue: '£33798'
  };

  opportunities: Opportunity[] = [
    {
      id: '1',
      name: 'lisa davis',
      address: '45 High Street, Upper Heyford, OX15 0SH',
      postcode: 'OX15 0SH',
      package: 'Premium Fiber',
      totalValue: '£599',
      speed: '500 Mbps',
      status: 'won',
      created: '11/13/2025',
      updated: '11/13/2025'
    },
    {
      id: '2',
      name: 'lisa davis',
      address: '45 High Street, Upper Heyford, OX15 0SH',
      postcode: 'OX15 0SH',
      package: 'Premium Fiber',
      totalValue: '£599',
      speed: '500 Mbps',
      status: 'qualified',
      created: '11/13/2025',
      updated: '11/13/2025'
    },
    {
      id: '3',
      name: 'lisa davis',
      address: '45 High Street, Upper Heyford, OX15 0SH',
      postcode: 'OX15 0SH',
      package: 'Premium Fiber',
      totalValue: '£599',
      speed: '500 Mbps',
      status: 'won',
      created: '11/13/2025',
      updated: '11/13/2025'
    },
    {
      id: '4',
      name: 'lisa davis',
      address: '45 High Street, Upper Heyford, OX15 0SH',
      postcode: 'OX15 0SH',
      package: 'Premium Fiber',
      totalValue: '£599',
      speed: '500 Mbps',
      status: 'open',
      created: '11/13/2025',
      updated: '11/13/2025'
    },
  ];

  filteredOpportunities: Opportunity[] = [];

  ngOnInit(): void {
    this.filterOpportunities('all');
  }

  filterOpportunities(status: 'all' | 'open' | 'qualified' | 'won' | 'lost'): void {
    this.selectedFilter = status;
    if (status === 'all') {
      this.filteredOpportunities = [...this.opportunities];
    } else {
      this.filteredOpportunities = this.opportunities.filter(opp => opp.status === status);
    }
  }

  getOpportunityCount(status: 'all' | 'open' | 'qualified' | 'won' | 'lost'): number {
    if (status === 'all') {
      return this.opportunities.length;
    }
    return this.opportunities.filter(opp => opp.status === status).length;
  }

  getStatusBadgeClass(status: string): string {
    return `status-badge status-${status}`;
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
